"use client";
import React from "react";
import classNames from "classnames";
import { ReactSVG } from "react-svg";
import { useRouter } from "next/navigation";
import { Button as ButtonLib } from "@npm_leadtech/qr-ui-components";
import { Banner } from "@/components/Banner";
import { Typography } from "@/components/Typography";
import { CardList } from "@/components/CardList";

import { BannerWrapperSize } from "@/components/Banner/types";
import { bannerAdvantagesProps } from "@/data/types/home";
import { paths } from "@/utils/paths";

import "./styles.scss";

export const KeepItSimpleModule = ({
  data,
  wrapperSize,
  setSource,
}: {
  data: bannerAdvantagesProps;
  wrapperSize: BannerWrapperSize;
  setSource?: (event: string) => void;
}) => {
  const {
    List,
    ctaLabel,
    richtext,
    customClass,
    ctaLabelShort,
    amplitudeEvent,
  } = data;

  const classnames = classNames(`home-advantages`, {
    [`home-advantages--${customClass}`]: customClass,
  });

  const router = useRouter();
  const handleCtaClick = () => {
    amplitudeEvent && setSource(amplitudeEvent);
    router.push(paths.qrEditor());
  };

  return (
    <Banner
      big
      white
      wrapperSize={wrapperSize}
      customClass="banner-cards">
      <div className={classnames}>
        <div className="home-advantages--header">
          {richtext.map((item, i: number) => (
            <Typography
              key={i}
              Tag={item.tag}
              size={item.size}
              spacing={item.spacing}>
              {item.list
                ? item.list.map((e, i) => (
                    <li key={i}>{<span dangerouslySetInnerHTML={{ __html: e["item"] }}></span>}</li>
                  ))
                : item.content}
            </Typography>
          ))}

          <div className="buttonWrapper cta-keepSimple cta-desktop">
            <ButtonLib
              dataQA="cta-desktop"
              onClick={handleCtaClick}
              label={ctaLabel}
              variant="secondary"
            />
          </div>

          <div className="buttonWrapper cta-keepSimple cta-mobile">
            <ButtonLib
              dataQA="cta-mobile"
              onClick={handleCtaClick}
              label={ctaLabelShort || ctaLabel}
              variant="secondary"
            />
          </div>
        </div>

        <div className="home-advantages--body">
          <CardList
            cardItems={List.map((item) => ({
              icon: (
                <ReactSVG
                  className="button__icon"
                  src={item.icon as string}
                />
              ),
              title: item.title,
              subtitle: item.subtitle,
            }))}
            showCarrousel={true}
          />
          <div className="buttonWrapper cta-keepSimple cta-mobile-bottom">
            <ButtonLib
              dataQA="cta-mobile"
              onClick={handleCtaClick}
              label={ctaLabelShort || ctaLabel}
              variant="secondary"
            />
          </div>
        </div>
      </div>
    </Banner>
  );
};
